const isTouchDevice = 'ontouchstart' in document.documentElement

export const isMobile = () => {
	return isTouchDevice
}
